export default function ComparisonTable() {
  const rows = [
    { feature: 'Product Discovery', traditional: 'Slow', vigorbuy: 'Fast' },
    { feature: 'Organization', traditional: 'Poor', vigorbuy: 'Structured' },
    { feature: 'Product Categories', traditional: 'Limited', vigorbuy: 'Multiple' },
    { feature: 'QC Information', traditional: 'Hard To Find', vigorbuy: 'Easy Access' },
    { feature: 'Beginner Friendly', traditional: 'Medium', vigorbuy: 'Excellent' },
    { feature: 'Time Saving', traditional: 'Low', vigorbuy: 'High' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          Why Choose Vigorbuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          See how the Vigorbuy Spreadsheet compares to traditional product searching methods.
        </p>

        <div className="overflow-hidden rounded-lg border border-background-200">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Feature</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-600">Traditional Search</th>
                <th className="text-left px-5 py-3.5 font-semibold text-accent-700">Vigorbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3 text-foreground-800 font-medium">{row.feature}</td>
                  <td className="px-5 py-3 text-foreground-500">{row.traditional}</td>
                  <td className="px-5 py-3 text-accent-700 font-medium">{row.vigorbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}